import React from 'react';
import './Services.css';
import './AboutUs.css';

const InvestorEducation = () => {
    const cardsData = [
        {
            title: 'Knowing Where to Invest',
            text: 'The first step to financial freedom is knowing where to invest. Identifying the right investment vehicles—such as mutual funds, stocks, bonds, or real estate—ensures that your choices align with your financial goals. Strategic investments can maximize returns while minimizing risks.',
        },
        {
            title: 'When to Invest',
            text: 'Timing is crucial in the world of investments. Knowing when to enter and exit the market helps you seize opportunities and avoid common pitfalls. With professional guidance, you can make informed decisions based on strategy rather than emotion, even during market fluctuations.',
        },
        {
            title: 'What to Invest In',
            text: 'Choosing the right assets to invest in depends on your financial objectives, risk tolerance, and time horizon. Mutual funds may be a popular choice, but they are not the only option. At <b className="services-bold">United Investment Point</b>, we work with you to evaluate all potential investments and select those that align with your path to financial success.',
        },
        {
            title: 'Investment Diversification',
            text: 'Diversification is a cornerstone of successful investing. By spreading your investments across various sectors and asset classes, you can mitigate risk and achieve more stable returns. Our team will help you build a tailored, diversified portfolio designed to meet your unique needs and goals.',
        },
    ];

    return (
        <div className="page investor-education-page about-page">
            <header className="about-header">
                <h1>Investor Education</h1>
                <p>
                    Successful investing is a journey that requires a clear understanding of where to invest, when to invest, and what to invest in.
                    With the right knowledge and carefully crafted strategies, you can make informed, confident decisions that pave the way to wealth accumulation
                    and financial independence. At <b className="services-bold">United Investment Point</b>, we are committed to being your trusted partner
                    in this journey, simplifying complex investment concepts and empowering you to make choices that align with your financial aspirations.
                </p>
                <p>
                    Whether you’re an experienced investor looking to refine your strategies or a beginner eager to build a solid foundation, we are here
                    to guide you every step of the way. Our expertise helps you navigate the intricacies of the investment world, from selecting high-potential
                    assets to building a diversified portfolio that balances growth and security. Professional advice is invaluable in mitigating risks, seizing
                    opportunities, and ensuring that every decision moves you closer to your long-term financial goals.
                </p>
                <p>
                    By leveraging our educational resources and personalized guidance, you can unlock the full potential of your investments, adapt to changing
                    market conditions, and create a legacy of financial stability and growth. Together, we’ll chart a path to success that reflects your unique
                    ambitions and priorities.
                </p>

            </header>
            <section className="about-cards">
                {cardsData.map((card, index) => (
                    <div className="card" key={index}>
                        <h3 className="card-title">{card.title}</h3>
                        <p className="card-text" dangerouslySetInnerHTML={{ __html: card.text }}></p>
                    </div>
                ))}
            </section>
        </div>
    );
};

export default InvestorEducation;
